
import { z } from "zod";

export const PhaseValues = ["COMPLETED", "PENDING_BACKFILL", "PENDING_FINAL_INSPECTION_COMPLETE", "PENDING_FINAL_INSPECTION_SCHEDULING", "PENDING_INSTALL_COMPLETE", "PENDING_INSTALL_SCHEDULING", "PENDING_INTRO_CALL", "PENDING_INVOICING", "PENDING_NTP", "PENDING_PAYMENT_RECEIVED", "PENDING_PERMIT_APPROVAL", "PENDING_PERMIT_SUBMISSION", "PENDING_QUOTE", "PENDING_SOW_CONFIRMATION", "PENDING_SUB_PROJECT_COMPLETION"] as const;
export const PhaseSchema = z.enum(PhaseValues);
export const Phase = PhaseSchema.enum;
export type Phase = (typeof PhaseValues)[number];
export const PhaseDisplayNames = { "COMPLETED": "Completed",
"PENDING_BACKFILL": "Pending backfill",
"PENDING_FINAL_INSPECTION_COMPLETE": "Pending final inspection complete",
"PENDING_FINAL_INSPECTION_SCHEDULING": "Pending final inspection scheduling",
"PENDING_INSTALL_COMPLETE": "Pending work complete",
"PENDING_INSTALL_SCHEDULING": "Pending work scheduling",
"PENDING_INTRO_CALL": "Pending intro call",
"PENDING_INVOICING": "Pending invoicing",
"PENDING_NTP": "Pending NTP",
"PENDING_PAYMENT_RECEIVED": "Pending payment received",
"PENDING_PERMIT_APPROVAL": "Pending permit approval",
"PENDING_PERMIT_SUBMISSION": "Pending permit submission",
"PENDING_QUOTE": "Pending quote",
"PENDING_SOW_CONFIRMATION": "Pending SOW confirmation",
"PENDING_SUB_PROJECT_COMPLETION": "Pending sub project completion", } satisfies Record<Phase, string>;
